export default (string) => string.normalize('NFD')
    .replace(/\p{Diacritic}/gu, '').replace(/\u0142/g, 'l').replace(/\u0141/g, 'L');
